<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import JobTitleBase from '../../../../../job_titles/components/JobTitleBase.vue'

definePage({
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
    featureFlags: 'job-titles',
  },
})

// The settings layout hands every tab the site; this one reads it from the site context instead
defineOptions({ inheritAttrs: false })
</script>

<template>
  <JobTitleBase />
</template>
